export interface DeliverableBreakdownItem {
  key: string;
  label: string;
  pct: number;
}

/** Per-deliverable completion across the portfolio, as labeled mini-bars. */
export function DeliverableBreakdown({ items }: { items: DeliverableBreakdownItem[] }) {
  return (
    <div className="flex flex-wrap gap-x-6 gap-y-2">
      {items.map((it) => (
        <div
          key={it.key}
          data-testid="deliverable-breakdown-item"
          data-key={it.key}
          className="min-w-[120px] flex-1"
        >
          <div className="mb-1 flex items-center justify-between text-xs">
            <span className="text-muted-foreground">{it.label}</span>
            <span className="font-semibold text-foreground">{it.pct}%</span>
          </div>
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
            <div
              data-testid="deliverable-bar-fill"
              className="h-full rounded-full bg-primary transition-all"
              style={{ width: `${it.pct}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
